/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './columntext.user.tpl.html';

angular
  .module('restore.columntext', [])
  /**
   * Controller for column text handler.
   */
  .controller('ColumnTextCtrl', function ($scope, $element, $filter) {
    var i18n = $filter('i18n');
    var replaceReturns = $filter('replaceReturns');

    $scope.showMoreText = i18n('SEE_LESS');
    $scope.showMoreClass = 'more';
    $scope.hideLink = true;

    $scope.clientHeight = $element.prop('offsetHeight');

    /**
     * Utility function to toggle the show more/show less class and text.
     */
    $scope.toggleShow = function () {
      if ($scope.showMoreText === i18n('SEE_MORE')) {
        $scope.showMoreText = i18n('SEE_LESS');
        $scope.showMoreClass = 'more';
      } else {
        $scope.showMoreText = i18n('SEE_MORE');
        $scope.showMoreClass = 'less';
      }
    };

    /**
     * Utility to set if the link should be shown or hidden.
     */
    $scope.showMe = function () {
      $scope.hideLink = false;
    };

    /**
     * Utility to format the content for display
     * @param {String} content - The content to format.
     * @returns {String} The formatted content.
     */
    $scope.format = function (content) {
      // Convert boolean values to their string representation
      if (_.isBoolean(content)) {
        content = content.toString();
      }

      // Replace returns with <br> tags
      return content ? replaceReturns(content) : '&nbsp;';
    };
  })
  /**
   * The directive for the column text container.
   */
  .directive('columntext', function () {
    return {
      templateUrl: 'restore/columntext/columntext.user.tpl.html',
      scope: {
        columnContent: '=content'
      },
      link: function (scope, element, attr) {
        var watcher = scope.$watch(
          function () {
            return attr.$$element[0].offsetHeight;
          },
          function (h) {
            // turn off the listener
            watcher();
            if (h > 47) {
              scope.hideLink = false;
              scope.toggleShow();
            }
          }
        );
      },
      controller: 'ColumnTextCtrl'
    };
  });
